import React, {useEffect, useMemo} from 'react';
import Link from "next/link";
import cookies from 'next-cookies';
import {useTranslation} from "next-i18next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import MainLayout from "../../../Layouts/MainLayout";
import MasterGallery from "../../../view/master/MasterGallery/MasterGallery";
import Information from "../../../view/master/Information";
import Service from "../../../view/master/Service";
import Review from "../../../view/master/Review/Review";
import MyInfo from "../../../components/MyInfo/MyInfo";
import AroundRightItem from "../../../components/AroundRightItem/AroundRightItem";
import MasterPageButton from "../../../components/MasterPageButton";
import {add_post_files_saga_act, master_data_act, master_review_act,} from "../../../store/actions/master";
import keys from "../../../services/keys";
import authApi from "../../../services/authinstance";
import translate_word from "../../../utils/translate";
import hooks from "../../../hooks/masterPageHook";
import styles from '../../../styles/Master.module.scss';
import {wrapper} from '../../../store';
import moment from "moment";
import {makeAbsolute} from "../../../utils/urlHelpers";
import {useDispatch} from "react-redux";
import {healthAndBeautyBusinessSchema} from "../../../services/rich-snippets/health-and-beauty-business-schema";
import {getISOCodeFromCountryName} from "../../../utils/getISOCodeFromCountryName";
import {parseOpeningHours} from "../../../utils/openingHours";

require("react");

const REPEATED_CLIENT_THRESHOLD = 4;

export const getServerSideProps = wrapper.getServerSideProps(async (ctx) => {
    const {token, lat, lng, user_id} = cookies(ctx);
    // if (!token) {
    //     return { loggedIn: false }
    // } else {
    //     setApiAuthorizationHeader(token)
    try {
        const response = await authApi.get(`${keys.SERVER_URL}userdetails/user/${ctx.query.id}/?is_master=true`);
        const master_services = await authApi.get(`${keys.SERVER_URL}userdetails/master-service/?user_id=${ctx.query.id}`);
        const reviews = await authApi.get(`${keys.SERVER_URL}timeline/review/?from_user=&to_user=${ctx.query.id}`);
        const planningRes = await authApi.get(`${keys.SERVER_URL}schedule/planning`)
        ctx.store.dispatch(master_data_act({...response.data, master_services: master_services.data.results}));
        ctx.store.dispatch(master_review_act({...reviews.data}));
        const masterId = Number(ctx.query.id);
        const planningList = planningRes?.data?.results.filter(p => p.master === masterId) || [];
        const openingHours = parseOpeningHours(planningList);
        // if (ctx.req) {
        //     await ctx.store.dispatch(master_data_saga({ token, id: ctx.query.id }));
        //     await ctx.store.dispatch(END);
        // }
        return {
            props: {
                ...(await serverSideTranslations(ctx.locale, ["common"])),
                language: ctx.locale,
                lat: lat ? lat : null,
                lng: lng ? lng : null,
                token: token || '',
                openingHours,
                absoluteUrl: makeAbsolute(ctx.req) || '',
                user_id: user_id || ctx.query.id,
                id: ctx.query.id,
                loggedIn: true,
            }
        };
    } catch (error) {
        return {
            props: {
                ...(await serverSideTranslations(ctx.locale, ["common"])),
                language: ctx.locale,
                items: null,
                token: token || '',
                absoluteUrl: makeAbsolute(ctx.req) || '',
                user_id: user_id || ctx.query.id,
                loggedIn: true,
            }
        };
    }
    // }
});

function Master(props) {
    const {
        activePage,
        review,
        master_data,
        location,
        translate,
        user,
        setActivePage,
        handleClick,
        category,
        find_go_home_price,
        get_room,
        router
    } = hooks(props);
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();

    const jsonLd = useMemo(() => {
        const data = master_data.data || {};
        const workAddress = data.master_work_address?.[0]?.work_address;
        const reviewsList = review.results || [];

        return healthAndBeautyBusinessSchema({
            name: [data.user?.first_name, data.user?.last_name].filter(Boolean).join(' '),
            image: data.image,
            description: data.about,
            ratingValue: data.rating,
            ratingCount: data.review_count,
            reviews: reviewsList.map((item) => ({
                reviewBody: item.comment,
                datePublished: moment(item.created_at).format('YYYY-MM-DD'),
                authorName: [item.from_user_details?.user?.first_name, item.from_user_details?.user?.last_name].filter(Boolean).join(' '),
                publisherName: translate_word(item.user_details?.service_name, i18n.language),
                itemReviewed: item.service
                    ? {
                        "@type": "Service",
                        name: item.service[`name_${i18n.language}`] || item.service.name_fr
                    }
                    : null
            })),
            address: workAddress
                ? {
                    streetAddress: workAddress.master_address,
                    addressLocality: workAddress.master_city,
                    // addressRegion: "", // отсутствует в API
                    postalCode: workAddress.master_zip,
                    addressCountry: getISOCodeFromCountryName(workAddress.master_country)
                }
                : null,
            priceRange: data.master_services?.[0]?.price
                ? `${t("priceFromMaster")}${parseFloat(data.master_services[0].price)}€`
                : null,
            url: `${props.absoluteUrl}/${i18n.language}${router.asPath}`,
            openingHours: props.openingHours,
            geo: workAddress
                ? {
                    latitude: workAddress.latitude,
                    longitude: workAddress.longitude
                }
                : null,
            sameAs: [`${props.absoluteUrl}/${i18n.language}${router.asPath}`],
            founderName: [data.user?.first_name, data.user?.last_name].filter(Boolean).join(' '),
            areaServed: workAddress?.master_city || null,
            serviceType: data.master_services?.map((s) =>
                s.service_details?.[`name_${i18n.language}`]
            ).filter(Boolean).join(", "),
            hasMap: workAddress?.latitude && workAddress?.longitude
                ? `https://maps.google.com/?q=${workAddress.latitude},${workAddress.longitude}`
                : null,
            bookingUrl: `${props.absoluteUrl}/master/${data.id}/register-master/`,
            // paymentAccepted: ["Cash", "Card"] // отсутствует в API
        })
    }, [])
    useEffect( () => {
        if (!props.id) return;
        dispatch(add_post_files_saga_act({token: props.token, user_id: props.id}));
    },[props.id])
    const _showPage = () => {
        switch (activePage) {
            case "gallery":
                return <MasterGallery
                    language={props.language}
                    loggedIn={props.loggedIn}
                    token={props.token}
                    id={props.id}
                    activePage={activePage}
                />;
            case "information":
                return <Information
                    loggedIn={props.loggedIn}
                    master_data={master_data}
                    openingHours={props.openingHours}
                    go_home_price={find_go_home_price()}
                />;
            case "service":
                return <Service
                    button_title={t("workScheduleLabel")}
                    loggedIn={props.loggedIn}
                    master={props.id}
                    client={user?.id}
                    master_data={master_data}
                    handleClick={(id) => {
                        handleClick(`/${props.language}/master/${props.id}/schedule`);
                    }}
                    category={category()}
                    token={props.token}
                />;
            case "review":
                return <Review
                    loggedIn={props.loggedIn}
                    token={props.token}
                    id={props.id}
                    button_title={t("schedule")}
                />;
            default:
                break;
        }
    };

    const {title, description, keywords} = useMemo(() => {
        const data = master_data.data || {};
        const masterServices = data.master_services || [];
	const cityDetails = data.city_details?.[`title_${i18n.language}`];
        const fallbackCity = data.master_work_address?.[0]?.work_address?.master_city;

	const cityNames = cityDetails || fallbackCity || '';
        const masterName = [data.user?.first_name, data.user?.last_name].filter(Boolean).join(' ');
	
       	const [serviceNames, subCategoryNames, categoryNames] = masterServices.reduce(
            ([services, subCategories, categories], ms) => {
                const serviceName = ms.service_details?.[`name_${i18n.language}`];
                const subCategoryName = ms.service_details?.sub_category?.[`name_${i18n.language}`];
                const categoryName = ms.service_details?.sub_category?.category?.[`name_${i18n.language}`];

                if (serviceName) services.push(serviceName);
                if (subCategoryName) subCategories.push(subCategoryName);
                if (categoryName) categories.push(categoryName);

                return [services, subCategories, categories];
            },
            [[], [], []]
        );

	const unique = (arr) => [...new Set(arr)];

        const uniqueServiceNames = unique(serviceNames);
        const uniqueSubCategories = unique(subCategoryNames);
        const uniqueCategories = unique(categoryNames);

        return {
            title: `${masterName} - ${uniqueSubCategories.join(', ')} ${t('in')} ${cityNames}`,
            description: `${uniqueServiceNames.join(', ')} ${t('in')} ${cityNames}`,
            keywords: `${uniqueServiceNames.join(', ')}, ${uniqueSubCategories.join(', ')} ${uniqueCategories.join(', ')} ${cityNames}`
        };
    }, [master_data.data]);

    return (
        // <div className="App">
        <MainLayout
            meta={description}
            title={title}
            page_title={title}
            keywords={keywords}
            page_image={master_data.data?.image}
            token={props.token}
            json_ld={jsonLd}
            language={props.language}
            id={user ? user.id : ""}
            user_image={user ? user.image : ""}>
            <div className={styles.profile}>
                <main className="container">
                
                    <div className="">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link as={`/${props.language}`} href={`/${props.language}`}>
                                        <a>{t("main")}</a>
                                    </Link>
                                </li>
                                <li
                                    className="breadcrumb-item active"
                                    aria-current="page">{t("masters_page")}</li>
                            </ol>
                        </nav>
                    </div>
                    {master_data.loading && master_data.data
                        ? <></>
                        : <div className="w-100 d-flex justify-content-between flex-wrap w-100">
                            <MyInfo
                                lat={props.lat}
                                lng={props.lng}
                                user={user}
                                image={master_data.data.image}
                                username={master_data.data.user?.username}
                                last_name={master_data.data.user
                                    ? master_data.data.user.last_name : ""}
                                first_name={master_data.data.user
                                    ? master_data.data.user.first_name : ""}
                                service_name={master_data.data.service_name
                                    ? translate_word(
                                        master_data.data.service_name,
                                        props.language) : ""}
                                review_count={master_data.data.review_count}
                                rating={master_data.data.rating}
                                location={location}
                                about={master_data.data.about}
                            />
                            <div className={`${styles.map_bottom} ${styles.for_mobile}`}>
                                {/* <span className={styles.title}>
                                    {t("aboutMaster")}
                                </span> */}
                                <div className={styles.description}>{master_data.data.about}</div>
                            </div>
                            <div className={styles.profile_right}>
                                {master_data.data.repeated_client_count > REPEATED_CLIENT_THRESHOLD && (<div className="d-flex justify-content-evenly profile-right-section mt-4">
                                    <div className="d-flex flex-column align-items-center">
                                        <span className={styles.number}>{master_data.data.posts_count}</span>
                                        <span className={styles.description}>{t("publications_works")}</span>
                                    </div>
                                    <div className="d-flex flex-column align-items-center">
                                        <span className={styles.number}>{master_data.data.done_order_count}</span>
                                        <span className={styles.description}>{t("completed_orders")}</span>
                                    </div>
                                    <div className="d-flex flex-column align-items-center">
                                        <span className={styles.number}>{master_data.data.repeated_client_count}</span>
                                        <span className={styles.description}>{t("repeated_calls")}</span>
                                    </div>
                                </div>)}

                                <div className="d-flex justify-content-between profile-right-section">
                                    <MasterPageButton onClick={() => setActivePage("gallery")}
                                                      activePage={activePage === "gallery" ? activePage : ""}
                                                      title={t("postsLabel")}
                                                      icon={
                                                          <span className="icon-publications">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                                <span className="path3"></span>
                                                <span className="path4"></span>
                                                <span className="path5"></span>
                                                <span className="path6"></span>
                                                <span className="path7"></span>
                                                <span className="path8"></span>
                                            </span>}
                                    />
                                    <MasterPageButton onClick={() => setActivePage("information")}
                                                      activePage={activePage === "information" ? activePage : ""}
                                                      title={t("infoLabel")}
                                                      icon={<span className="icon-Information">
                                            <span className="path1"></span>
                                            <span className="path3"></span>
                                            <span className="path5"></span>
                                        </span>}/>
                                    <MasterPageButton onClick={() => setActivePage("service")}
                                                      activePage={activePage === "service" ? activePage : ""}
                                                      title={t("regisForService")}
                                                      icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                          <path
                                                              d="M20.5 8H3.5M6 21H18C19.6569 21 21 19.6569 21 18V8C21 6.34315 19.6569 5 18 5H6C4.34315 5 3 6.34315 3 8V18C3 19.6569 4.34315 21 6 21Z"
                                                              stroke={activePage === "service" ? "white" : "#F99DA1"}
                                                              stroke-width="1.8" stroke-linecap="round"/>
                                                          <path d="M7.5 5V2.75"
                                                                stroke={activePage === "service" ? "white" : "#F99DA1"}
                                                                stroke-width="1.8" stroke-linecap="round"
                                                                stroke-linejoin="round"/>
                                                          <path d="M16.5 5V2.75"
                                                                stroke={activePage === "service" ? "white" : "#F99DA1"}
                                                                stroke-width="1.8" stroke-linecap="round"
                                                                stroke-linejoin="round"/>
                                                          <path
                                                              d="M8.25 17.5H6.75M8.25 14.5H6.75M8.25 11.5H6.75M12.75 17.5H11.25M12.75 14.5H11.25M12.75 11.5H11.25M17.25 17.5H15.75M17.25 14.5H15.75M17.25 11.5H15.75"
                                                              stroke={activePage === "service" ? "white" : "#F99DA1"}
                                                              stroke-width="1.8" stroke-linecap="round"/>
                                                      </svg>}/>
                                    <MasterPageButton onClick={() => setActivePage("review")}
                                                      activePage={activePage === "review" ? activePage : ""}
                                                      title={t("reviewsLabel")}
                                                      icon={<span className="icon-testimonials"/>}/>
                                </div>
                            </div>

                        </div>}
                    <div className="w-100">
                        {_showPage()}
                    </div>
                </main>
            </div>
        </MainLayout>
    );
}

export default Master;
